module.exports = __webpack_public_path__ + "img/passport-stamps-5.6bc6b9de.jpg";